// extracted by mini-css-extract-plugin
module.exports = {"styledButton":"R6bj7zD_"};